import { type ReactNode, StrictMode, Suspense } from 'react'

import '@mantine/charts/styles.css'
import { MantineProvider, useMantineColorScheme } from '@mantine/core'
import '@mantine/core/styles.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { UserfrontProvider } from '@userfront/react'
import FontFaceObserver from 'fontfaceobserver'
import { WagmiProvider } from 'wagmi'

import { make_config } from '@repo/common/blockchain/config'
import '@repo/common/core/global.css'

import { theme } from './theme'

// Using Mantine's built-in color scheme functionality

const config = make_config({
  appLogoUrl: 'https://fission.xyz/logo.png',
  appName: 'Fission™',
})

const queryClient = new QueryClient({})

export { QueryClient }

const font_header = new FontFaceObserver('Lausanne')
font_header
  .load()
  .then(() => {
    document.documentElement.dataset.fontLoaded = 'true'
  })
  .catch(console.warn)

// issue: https://fission-xyz.sentry.io/issues/5984392344/events/23fe7f606ed0416daaf00dde6e2be4e2/
// https://stackoverflow.com/questions/65152373/typescript-serialize-bigint-in-json
// @ts-expect-error: polyfill for the JSON.stringify method for BigInt
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface BigInt {
  /** Convert to BigInt to string form in JSON.stringify */
  toJSON: () => string
}
// @ts-expect-error: polyfill for the JSON.stringify method for BigInt
BigInt.prototype.toJSON = function () {
  return this.toString()
}

export function AppContexts({
  queryClient: client = queryClient,
  children,
}: {
  queryClient?: QueryClient
  children: ReactNode
}) {
  return (
    <StrictMode>
      <Suspense fallback={<>Loading</>}>
        <WagmiProvider config={config}>
          <QueryClientProvider client={client}>
            <MantineProvider theme={theme} defaultColorScheme="dark">
              {}
              <UserfrontProvider tenantId="vbq7rrzb">
                {children}
              </UserfrontProvider>
            </MantineProvider>
            <ReactQueryDevtools />
          </QueryClientProvider>
        </WagmiProvider>
      </Suspense>
    </StrictMode>
  )
}

// Export the Mantine useMantineColorScheme hook for convenience
export const useColorScheme = () => {
  const { colorScheme, setColorScheme } = useMantineColorScheme()

  const toggleColorScheme = () => {
    setColorScheme(colorScheme === 'dark' ? 'light' : 'dark')
  }

  return { colorScheme, toggleColorScheme }
}
